import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import LogInModal from 'flarum/forum/components/LogInModal';
import avatar from 'flarum/common/helpers/avatar';
import Link from 'flarum/common/components/Link';

export default class GroupDetailPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    
    // 从路由参数获取群组ID
    this.groupId = m.route.param('id');
    this.group = null;
    this.subGroups = [];
    this.loading = true;
    this.error = null;
    this.currentView = 'overview'; // 'overview', 'subgroups', 'discussions'
    this.isMember = false; // 用户是否为群组成员
    this.isAdmin = false; // 用户是否为群组管理员
    this.memberStatus = null; // 成员状态：'approved', 'pending', null
    
    // 创建DiscussionListState来管理discussions
    this.discussionListState = null

    
    this.loadGroupData();
  }

  className() {
    return 'GroupDetailPage';
  }

  title() {
    return this.group ? this.group.name : app.translator.trans('tf-groups.forum.group-detail.title');
  }

  view() {
    if (this.loading) {
      return (
        <div className="GroupDetailPage">
          <div className="container">
            <div className="loading-container">
              <div className="loading-spinner">
                <i className="fa-light fa-spinner fa-spin"></i>
              </div>
              <div className="loading-text">{app.translator.trans('tf-groups.forum.group-detail.loading')}</div>
            </div>
          </div>
        </div>
      );
    }

    if (this.error) {
      return (
        <div className="GroupDetailPage">
          <div className="container">
            <div className="error-container">
              <div className="error-icon">
                <i className="fa-light fa-exclamation-triangle"></i>
              </div>
              <div className="error-message">{this.error}</div>
              <Button 
                className="Button Button--primary"
                onclick={() => this.loadGroupData()}
              >
                {app.translator.trans('tf-groups.forum.group-detail.retry')}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    if (!this.group) {
      return (
        <div className="GroupDetailPage">
          <div className="container">
            <div className="not-found">
              <h2>{app.translator.trans('tf-groups.forum.group-detail.not-found')}</h2>
              <p>{app.translator.trans('tf-groups.forum.group-detail.not-found-message')}</p>
              <Button 
                className="Button Button--primary"
                onclick={() => m.route.set('/')}
              >
                {app.translator.trans('tf-groups.forum.group-detail.back-to-home')}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="GroupDetailPage">
        <div className="">
          {/* 内容区域 */}
          <div className="group-content">
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    if(this.group.is_container) {
      return this.renderParentGroupLayout();
    }else{
      return this.renderNonContainerLayout();
    }
  }

  // 渲染非容器群组的布局
  renderNonContainerLayout() {
    const coverImageUrl = this.group.cover_image ? this.getImageUrl(this.group.cover_image) : null;
    
    return (
      <div className="non-container-layout">
        {/* 群组头部 - 通栏背景图 */}
        <div 
          className="group-banner" 
          style={coverImageUrl ? {
            backgroundImage: `url(${coverImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          } : {}}
        >
          <div className="group-banner-overlay">
            <h1 className="group-banner-title">{this.group.name}</h1>
          </div>
        </div>

        {/* 主要内容区域 */}
        {/* 非课程群组显示统计栏 */}
        {!this.group.is_course && (
        <div className="group-stats-bar">
              <div className="group-stats-bar-item">
              <div className="stat-item">
                <span className="stat-label"> <i className="fa-light fa-comments stat-icon"></i>{app.translator.trans('tf-groups.forum.group-detail.topics')}</span>
                <span className="stat-number">{this.group.stats.topics}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label"><i className="fa-light fa-comment stat-icon"></i>{app.translator.trans('tf-groups.forum.group-detail.posts')}</span>
                <span className="stat-number">{this.group.stats.posts}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label"><i className="fa-light fa-user-group stat-icon"></i>{app.translator.trans('tf-groups.forum.group-detail.members')}</span>
                <span className="stat-number">{this.group.stats.members}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label"><i className="fa-light fa-fire stat-icon"></i>{app.translator.trans('tf-groups.forum.group-detail.activity')}</span>
                <span className="stat-number">{this.group.stats.topics+this.group.stats.posts}</span>
              </div>
              </div>
              {!this.isMember && app.session.user && (
                <Button 
                  className="Button Button--primary group-join-button"
                  onclick={() => this.joinGroup()}
                >
                  {app.translator.trans('tf-groups.forum.group-detail.join-this-group')}
                </Button>
              )}
              {this.isMember && (
                <Button 
                  className="Button Button--primary group-post-topic-button"
                  onclick={() => this.postTopic()}
                >
                  {app.translator.trans('tf-groups.forum.group-detail.post-a-topic')}
                </Button>
              )}
            </div>
        )}
        <div className={`mian ${this.group.is_course ? 'mian--course' : ''}`}>
          {/* 左侧内容 */}
          <div className="content-main">
            {/* 课程群组显示老师信息和内容介绍 */}
            {this.group.is_course && (
              <div className="course-info-sections">
                {/* 老师信息板块 - 显示作者信息或版主信息 */}
                {(() => {
                  const courseInfo = this.group.course_info || {};
                  const hasAuthor = courseInfo.author_name;
                  
                  // 如果有作者信息，显示作者信息；否则显示版主信息
                  if (hasAuthor) {
                    return (
                      <div className="course-teacher-section">
                        <div className="course-teacher-card">
                          <div className="teacher-avatar">
                            <div className="teacher-avatar-placeholder">
                              {(courseInfo.author_name || 'A').charAt(0).toUpperCase()}
                            </div>
                          </div>
                          <div className="teacher-info">
                            <h2 className="teacher-name">{courseInfo.author_name}</h2>
                            {courseInfo.author_intro && (
                              <p className="teacher-description">{courseInfo.author_intro}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  } else if (this.group.admins && this.group.admins.length > 0) {
                    return (
                      <div className="course-teacher-section">
                        {this.group.admins.slice(0, 1).map((admin, index) => (
                          <div key={admin.id || index} className="course-teacher-card">
                            <div className="teacher-avatar">
                              {admin.avatar_url ? (
                                <img 
                                  src={this.getImageUrl(admin.avatar_url)} 
                                  alt={admin.display_name || admin.username}
                                  className="teacher-avatar-image"
                                />
                              ) : (
                                <div className="teacher-avatar-placeholder">
                                  {(admin.display_name || admin.username || 'T').charAt(0).toUpperCase()}
                                </div>
                              )}
                            </div>
                            <div className="teacher-info">
                              <h2 className="teacher-name">{admin.display_name || admin.username}</h2>
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  }
                  return null;
                })()}

                {/* 内容介绍板块 */}
                {(this.group.description || this.group.course_info || app.session.user) && (
                  <div className="course-description-section">
                    <h2 className="course-section-title">{app.translator.trans('tf-groups.forum.group-detail.course-description')}</h2>
                    <div className="course-description-content">
                      {this.group.description && <p>{this.group.description}</p>}
                      {/* 购买按钮 和 My Orders */}
                      <div className="course-purchase-button-wrapper">
                        <Button
                          className="Button Button--primary course-purchase-button"
                          onclick={() => this.handleCoursePurchaseClick()}
                        >
                          {app.translator.trans('tf-groups.forum.group-detail.purchase-course')}
                        </Button>
                        {app.session.user && (
                          <Button
                            className="Button Button--secondary course-my-orders-button"
                            onclick={() => this.handleMyOrdersClick()}
                          >
                            {app.translator.trans('tf-groups.forum.group-detail.my-orders')}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* 讨论列表 */}
            <div className="discussions-section">
              {/* <h2>Discussions</h2> */}
              <div className={this.group.is_course ? "course-lessons-grid" : "discussions-list"}>
                {this.group.is_course ? this.renderCourseLessons() : this.renderDiscussionsList()}
            </div>
          </div>
        </div>

          {/* 右侧边栏 - 课程群组不显示 */}
          {!this.group.is_course && (
          <div className="content-sidebar">
            {/* 用户信息卡片 */}
            {this.group.creator && (
              <div className="sidebar-widget user-card">
                <div className="user-avatar">
                  {this.group.creator.avatar_url ? (
                    <img 
                      src={this.getImageUrl(this.group.creator.avatar_url)} 
                      alt={this.group.creator.display_name || this.group.creator.username}
                      className="user-avatar-image"
                    />
                  ) : (
                    <div className="user-avatar-placeholder">
                      {(this.group.creator.display_name || this.group.creator.username || 'U').charAt(0).toUpperCase()}
                    </div>
                    
                  )}
                </div>
                <div className="user-name">
                  {this.group.creator.display_name || this.group.creator.username}
                </div>
                <div className="user-point">
                <div className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.current-points')}</div>
                  <div className="stat-value">{this.formatPointsFromCreator(this.group.creator)}</div>
                </div>
                <div className="user-stats">
                  <div className="stat-item">
                    <span className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.last-login')}</span>
                    <span className="stat-value">{this.formatLastLoginFromCreator(this.group.creator)}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.joined-community')}</span>
                    <span className="stat-value">{this.formatJoinedDateFromCreator(this.group.creator)}</span>
                  </div>
                </div>
              </div>
            )}

            {/* 关于群组 */}
            <div className=" about-group">
              <h3 className="about-title">{app.translator.trans('tf-groups.forum.group-detail.about')}</h3>
              
                <div className="group-meta sidebar-widget">
                <h4 className="about-group-name">{this.group.name}</h4>
                <p className="about-description">{this.group.description || app.translator.trans('tf-groups.forum.group-detail.no-description')}</p>
                <div className="meta-item">
                  <span className="meta-key">{app.translator.trans('tf-groups.forum.group-detail.type')}</span>
                  <span className="meta-value">{this.group.privacy === 'public' ? app.translator.trans('tf-groups.forum.group-detail.public-group') : app.translator.trans('tf-groups.forum.group-detail.private-group')}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-key">{app.translator.trans('tf-groups.forum.group-detail.since')}</span>
                  <span className="meta-value">{new Date(this.group.created_at).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</span>
                </div>
              </div>
            </div>

            {/* 群组成员 */}
            {!this.group.is_container && (
              <div className="group-members">
                <h3 className="members-title">{app.translator.trans('tf-groups.forum.group-detail.members')}</h3>
                <div className="members-avatars sidebar-widget">
                  {this.group.members && this.group.members.length > 0 ? (
                    <div className="members-avatars-list">
                      {this.group.members.slice(0, 5).map((member, index) => {
                        if (!member) return null;
                        const user = member.user || member;
                        if (!user) return null;
                        return (
                          <div 
                            key={user.id || index}
                            className="member-avatar-item"
                          >
                            {user.avatar_url ? (
                              <img 
                                src={this.getImageUrl(user.avatar_url)} 
                                alt={user.display_name || user.username || 'User'}
                                className="member-avatar"
                              />
                            ) : (
                              <div className="member-avatar member-avatar-placeholder">
                                {(user.display_name || user.username || 'U').charAt(0).toUpperCase()}
                              </div>
                            )}
                          </div>
                        );
                      }).filter(item => item !== null)}
                      {this.group.members && this.group.members.length > 5 && (
                        <div className="member-count-badge">
                          {this.group.members.length - 5}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="no-members">{app.translator.trans('tf-groups.forum.group-detail.no-members')}</div>
                  )}
                </div>
                {/* {this.isMember && (
                  <Button 
                    className="Button Button--default group-leave-button"
                    onclick={() => this.leaveGroup()}
                  >
                    Leave this Group
                  </Button>
                )} */}
              </div>
            )}

            {/* 群组操作按钮 */}
            {this.renderGroupActions()}
          </div>
          )}
        </div>
      </div>
    );
  }

  // 渲染父群组的特殊布局
  renderParentGroupLayout() {
    const coverImageUrl = this.group.cover_image ? this.getImageUrl(this.group.cover_image) : null;
    const totalConversations = this.subGroups.reduce((sum, group) => sum + (group.stats?.conversations || 0), 0);
    const totalReplies = this.subGroups.reduce((sum, group) => sum + (group.stats?.replies || 0), 0);
    const totalMembers = this.subGroups.reduce((sum, group) => sum + (group.stats?.members || group.member_count || 0), 0);

    return (
      <div className="parent-group-layout">
        {/* 群组头部 - 通栏背景图 */}
        <div 
          className="group-banner" 
          style={coverImageUrl ? {
            backgroundImage: `url(${coverImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          } : {}}
        >
          <div className="group-banner-overlay">
            <h1 className="group-banner-title">{this.group.name}</h1>
          </div>
        </div>

        {/* 主要内容区域 */}
        <div className={`mian ${this.group.is_course ? 'mian--course' : ''}`}>
          {/* 左侧内容 */}
          <div className="content-main">
            {/* 子群组网格 */}
            <div className="groups-list-grid">
              {this.subGroups && this.subGroups.length > 0 ? this.subGroups.map(subGroup => this.renderSubGroupCard(subGroup)) : (
                <div className="no-groups">{app.translator.trans('tf-groups.forum.group-detail.no-subgroups')}</div>
              )}
            </div>
          </div>

          {/* 右侧边栏 - 课程群组不显示 */}
          {!this.group.is_course && (
          <div className="content-sidebar">
            {/* 用户信息卡片 */}
            {this.group.creator && (
              <div className="sidebar-widget user-card">
                <div className="user-avatar">
                  {this.group.creator.avatar_url ? (
                    <img 
                      src={this.getImageUrl(this.group.creator.avatar_url)} 
                      alt={this.group.creator.display_name || this.group.creator.username}
                      className="user-avatar-image"
                    />
                  ) : (
                    <div className="user-avatar-placeholder">
                      {(this.group.creator.display_name || this.group.creator.username || 'U').charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="user-name">
                  {this.group.creator.display_name || this.group.creator.username}
                </div>
                <div className="user-stats">
                  <div className="stat-item">
                    <span className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.last-login')}</span>
                    <span className="stat-value">{this.formatLastLoginFromCreator(this.group.creator)}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.joined-community')}</span>
                    <span className="stat-value">{this.formatJoinedDateFromCreator(this.group.creator)}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">{app.translator.trans('tf-groups.forum.group-detail.current-points')}</span>
                    <span className="stat-value">{this.formatPointsFromCreator(this.group.creator)}</span>
                  </div>
                </div>
              </div>
            )}

            {/* 关于群组 */}
            <div className=" about-group">
              <h3 className="about-title">{app.translator.trans('tf-groups.forum.group-detail.about')}</h3>
              
              <div className="group-meta sidebar-widget">
                <h4 className="about-group-name">{this.group.name}</h4>
                <p className="about-description">{this.group.description || app.translator.trans('tf-groups.forum.group-detail.no-description')}</p>
                <div className="meta-item">
                  <span className="meta-key">{app.translator.trans('tf-groups.forum.group-detail.type')}</span>
                  <span className="meta-value">{this.group.privacy === 'public' ? app.translator.trans('tf-groups.forum.group-detail.public-group') : app.translator.trans('tf-groups.forum.group-detail.private-group')}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-key">{app.translator.trans('tf-groups.forum.group-detail.since')}</span>
                  <span className="meta-value">{new Date(this.group.created_at).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</span>
                </div>
              </div>
            </div>

            {/* 群组成员 */}
            {!this.group.is_container && ( 
            <div className="group-members">
              <h3 className="members-title">{app.translator.trans('tf-groups.forum.group-detail.members')}</h3>
              <div className="members-avatars sidebar-widget">
                {this.group.members && this.group.members.length > 0 ? (
                  <div className="members-avatars-list">
                    {this.group.members.slice(0, 5).map((member, index) => {
                      if (!member) return null;
                      const user = member.user || member;
                      if (!user) return null;
                      return (
                        <div 
                          key={user.id || index}
                          className="member-avatar-item"
                        >
                          {user.avatar_url ? (
                            <img 
                              src={this.getImageUrl(user.avatar_url)} 
                              alt={user.display_name || user.username || 'User'}
                              className="member-avatar"
                            />
                          ) : (
                            <div className="member-avatar member-avatar-placeholder">
                              {(user.display_name || user.username || 'U').charAt(0).toUpperCase()}
                            </div>
                          )}
                        </div>
                      );
                    }).filter(item => item !== null)}
                    {this.group.members && this.group.members.length > 5 && (
                      <div className="member-count-badge">
                        {this.group.members.length - 5}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="no-members">{app.translator.trans('tf-groups.forum.group-detail.no-members')}</div>
                )}
              </div>
            </div>)}

            {/* 群组操作按钮 */}
            {this.renderGroupActions()}
          </div>
          )}
        </div>
      </div>
    );
  }


  async loadGroupData() {
    this.loading = true;
    this.error = null;
    m.redraw();

    try {
      // 加载群组详情
      const groupResponse = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups/frontend/' + this.groupId
      });

      if (groupResponse && groupResponse.data) {
        this.group = groupResponse.data;
        console.log('[tf/wechat] GroupDetailPage: group loaded, name:', this.group?.name);
        // 微信分享配置（课程群组页：title、desc、imgUrl）
        if (typeof app.setWechatShareConfig === 'function') {
          const baseUrl = app.forum.attribute('baseUrl') || '';
          let title, desc, imgUrl;
          if (this.group.name === 'TheBrief') {
            title = 'Writing for Impact';
            desc = 'This 14-lesson masterclass teaches you what writing courses miss: how to connect.';
            imgUrl = 'https://community.citynewsservice.cn/assets/social_groups/1770627454_58MbqsGiHz.jpg';
          } else {
            title = this.group.name;
            desc = this.group.description || '';
            imgUrl = this.group.cover_image
              ? (this.group.cover_image.startsWith('http') ? this.group.cover_image : baseUrl + '/' + this.group.cover_image.replace(/^\//, ''))
              : '';
          }
          const shareConfig = { title, desc, link: window.location.href.split('#')[0], imgUrl };
          console.log('[tf/wechat] GroupDetailPage: calling setWechatShareConfig, shareConfig:', shareConfig);
          app.setWechatShareConfig(shareConfig);
        } else {
          console.warn('[tf/wechat] GroupDetailPage: app.setWechatShareConfig is not a function, wechat plugin may not be loaded');
        }
        
        // 检查用户成员状态
        this.checkMemberStatus();
        
        // 如果是容器群组，加载子群组
        if (this.group.is_container) {
          await this.loadSubGroups();
        }
        
        // 加载群组讨论
        await this.loadDiscussions();
      } else {
        this.error = app.translator.trans('tf-groups.forum.group-detail.not-found');
      }
    } catch (error) {
      console.error('Error loading group data:', error);
      this.error = app.translator.trans('tf-groups.forum.group-detail.load-error');
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async loadDiscussions(page = 1) {
    if (!this.group || !this.group.tag?.slug) {
      this.discussionListState = new DiscussionListState(); // 避免空报错
      return;
    }
    
    try {
      // 直接使用API获取该tag下的discussions
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/discussions',
        params: {
          'filter[tag]': this.group.tag.slug,
          'include': 'user,lastPostedUser,tags,tags.parent,firstPost',
          'sort': '-lastPostedAt',
          'page[offset]': (page - 1) * 20, // 每页20条
          'page[limit]': 20
        }
      });
      
      // 将API响应数据存储到store中
      if (response.data && response.data.length > 0) {
        // 过滤掉 null 值和不完整的数据，避免 Store 错误
        const validData = response.data;
        const validIncluded = (response.included || []).filter(item => item && item.type && item.id);
        
        // 构建清理后的响应对象
        const cleanedResponse = {
          data: validData,
          included: validIncluded,
          links: response.links,
          meta: response.meta
        };
        
        // 使用pushPayload存储完整的API响应
        if (validData.length > 0) {
          try {
            app.store.pushPayload(cleanedResponse);
          } catch (e) {
            console.error('Error pushing payload to store:', e);
          }
        }
        
        // 从store中获取discussions
        const discussions = validData.map(discussionData => {
          try {
            return app.store.getById('discussions', discussionData.id);
          } catch (e) {
            console.error('Error getting discussion from store:', e);
            return null;
          }
        }).filter(discussion => discussion); // 过滤掉undefined和null
        
        // 如果是课程群组，批量检查用户对每个付费课程的权限
        if (this.group.is_course && app.session.user) {
          await this.checkDiscussionsAccess(discussions);
        }
        
        // 如果是第一页，创建新的DiscussionListState
        if (page === 1) {
          this.discussionListState = new DiscussionListState({
            filter: { tag: this.group.tag.slug },
            sort: 'latest',
          });
          
          // 重写 loadMore 方法以支持自定义分页加载
          const self = this;
          this.discussionListState.loadMore = async () => {
            // 获取当前最后一页的页码
            const pages = this.discussionListState.pages;
            const lastPage = pages.length > 0 ? Math.max(...pages.map(p => p.number)) : 0;
            const nextPage = lastPage + 1;
            await self.loadDiscussions(nextPage);
            m.redraw();
          };
        }
        
        // 从响应中获取分页信息
        const links = response.links || {};
        const meta = response.meta || {};
        // 计算是否有下一页：检查 links.next 或根据返回的数据量判断
        // 如果返回的数据量等于每页限制（20），可能还有下一页
        const hasNext = !!links.next || (response.data.length === 20);
        const hasPrev = page > 1;
        
        // 检查是否已存在该页
        const existingPage = this.discussionListState.pages.find(p => p.number === page);
        if (existingPage) {
          // 更新现有页面
          existingPage.items = discussions;
          existingPage.hasNext = hasNext;
          existingPage.hasPrev = hasPrev;
        } else {
          // 创建新页面
          const newPage = {
            number: page,
            items: discussions,
            hasNext: hasNext,
            hasPrev: hasPrev,
          };
          this.discussionListState.pages.push(newPage);
          // 按页码排序
          this.discussionListState.pages.sort((a, b) => a.number - b.number);
        }
        
        // 更新DiscussionListState的当前页和总页数
        this.discussionListState.page = page;
        if (meta.total) {
          this.discussionListState.total = meta.total;
        }
      } else {
        // 没有数据时，如果是第一页，创建空的DiscussionListState
        if (page === 1) {
          this.discussionListState = new DiscussionListState({
            filter: { tag: this.group.tag.slug },
            sort: 'latest',
          });
        }
      }
      
    } catch (e) {
      console.error('Error loading discussions:', e);
      // 出错时，如果是第一页，创建空的DiscussionListState
      if (page === 1) {
        this.discussionListState = new DiscussionListState({
          filter: { tag: this.group.tag.slug },
          sort: 'latest',
        });
      }
    }
  }

  async loadSubGroups() {
    try {
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups/frontend?parent_id=' + this.groupId,
        params: { parent_id: this.groupId }
      });

      if (response && response.data) {
        // 获取每个子群组的详细信息，包括成员列表
        const subGroupsData = await Promise.all(
          response.data.map(async (group) => {
            let members = [];
            let commentCount = 0;
            
            // 获取子群组详细信息，包括成员列表
            try {
              const groupDetail = await app.request({
                method: 'GET',
                url: app.forum.attribute('apiUrl') + `/social-groups/frontend/${group.id}`,
              });
              
              if (groupDetail && groupDetail.data) {
                members = groupDetail.data.members || [];
                commentCount = (groupDetail.data.stats && groupDetail.data.stats.replies) || 0;
              }
            } catch (e) {
              console.warn('Error loading subgroup details:', e);
            }
            
            return {
              id: group.id,
              name: group.name || app.translator.trans('tf-groups.forum.group-detail.unnamed-group'),
              description: group.description || '',
              memberCount: group.member_count || 0,
              coverImage: group.cover_image || null,
              privacy: group.privacy || 'public',
              isContainer: group.is_container || false,
              parentId: group.parent_id || null,
              parent: group.parent || null,
              children: group.children || [],
              contact: group.contact || null,
              createdAt: group.created_at,
              updatedAt: group.updated_at,
              members: members.slice(0, 5), // 只取前5个成员用于头像显示
              commentCount: commentCount,
              stats: group.stats || { replies: 0 },
            };
          })
        );
        
        this.subGroups = subGroupsData;
      }
    } catch (error) {
      console.error('Error loading sub groups:', error);
      this.subGroups = [];
    }
  }

  renderSubGroupCard(group) {
    // 截断描述文本，限制为3行
    const truncateDescription = (text, maxLength = 150) => {
      if (!text) return app.translator.trans('tf-groups.forum.group-detail.no-description');
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    };

    const coverImageUrl = group.coverImage 
      ? (group.coverImage.startsWith('http') ? group.coverImage : this.getImageUrl(group.coverImage))
      : null;

    return (
      <div 
        className="group-card" 
        key={group.id}
        onclick={() => this.viewSubGroup(group)}
      >
        {/* 顶部图片区域 - 圆角 */}
        <div className="group-card-image" style={coverImageUrl ? {
          backgroundImage: `url(${coverImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        } : {}}>
          {!coverImageUrl && (
            <div className="group-card-image-placeholder">
              <i className="fa-light fa-user-group"></i>
            </div>
          )}
        </div>
        
        {/* 内容区域 - 白色背景 */}
        <div className="group-card-content">
          <h3 className="group-card-title">{group.name || app.translator.trans('tf-groups.forum.group-detail.unnamed-group')}</h3>
          
          {/* 描述文字 - 限制3行 */}
          <div className="group-card-description">
            {truncateDescription(group.description)}
          </div>
          
          {/* 底部交互元素 */}
          <div className="group-card-footer">
            {/* 左侧：用户头像（重叠显示） */}
            <div className="group-card-avatars">
              {group.members && group.members.length > 0 ? (
                group.members.slice(0, 3).map((member, idx) => {
                  if (!member) return null;
                  const user = member.user || member;
                  const userObj = user && typeof user === 'object' ? user : {
                    id: member.id || idx,
                    username: member.username || 'user',
                    displayName: member.display_name || member.username || 'User',
                    avatarUrl: member.avatar_url || null
                  };
                  
                  if (!userObj) return null;
                  
                  return (
                    <div 
                      key={userObj.id || idx} 
                      className="group-card-avatar"
                      style={{ zIndex: 10 - idx }}
                    >
                      {userObj.avatarUrl ? (
                        <img src={this.getImageUrl(userObj.avatarUrl)} alt={userObj.displayName || userObj.username || 'User'} />
                      ) : (
                        <div className="group-card-avatar-placeholder">
                          {(userObj.displayName || userObj.username || 'U').charAt(0).toUpperCase()}
                        </div>
                      )}
                    </div>
                  );
                }).filter(item => item !== null)
              ) : (
                // 如果没有成员数据，显示占位头像
                Array.from({ length: Math.min(group.memberCount || 0, 3) }).map((_, idx) => (
                  <div 
                    key={idx} 
                    className="group-card-avatar group-card-avatar-placeholder"
                    style={{ zIndex: 10 - idx }}
                  >
                    <i className="fa-light fa-user-group"></i>
                  </div>
                ))
              )}
            </div>
            
            {/* 右侧：指标 */}
            <div className="group-card-metrics">
              <div className="group-card-metric">
                <i className="fa-light fa-user-group"></i>
                <span>{group.memberCount || 0}</span>
              </div>
              <div className="group-card-metric">
                <i className="fa-light fa-comments"></i>
                <span>{group.stats.replies}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  viewSubGroup(subGroup) {
    // 跳转到子群组详情页面
    // m.route.set('/groups/' + subGroup.id);
    m.route.set(app.route('groupDetail', { id: subGroup.id }));

  }

  viewAllMembers() {
    // 查看所有成员的功能
  }

  // 获取完整的图片URL
  getImageUrl(imagePath) {
    if (!imagePath) return '';
    
    // 如果已经是完整URL，直接返回
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    
    // 如果是相对路径，添加基础URL
    const baseUrl = app.forum.attribute('baseUrl') || '';
    return baseUrl + '/' + imagePath;
  }

  handleCoursePurchaseClick() {
    const purchaseUrl = this.group?.course_info?.ec_purchase_url;
    if (!purchaseUrl) {
      app.alerts.show({ type: 'error' }, 'Purchase link is unavailable now.');
      return;
    }

    // 未登录购买时直接跳转目标地址，不走 SSO
    if (!app.session.user) {
      window.open(purchaseUrl, '_blank');
      return;
    }

    this.openSsoTargetUrl(purchaseUrl);
  }

  handleMyOrdersClick() {
    const myOrdersUrl = 'https://e.citynewsservice.cn/user/order_list?type=1';

    // 未登录先拉起登录，登录后仍停留在当前页面
    if (!app.session.user) {
      app.modal.show(LogInModal);
      return;
    }

    this.openSsoTargetUrl(myOrdersUrl);
  }

  async openSsoTargetUrl(targetUrl) {
    if (!targetUrl) return;

    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/build-unattended-entry-url',
        body: {
          target_url: targetUrl,
        },
      });

      // 200 时优先跳转接口返回的 data.url，缺失时回退到原始 targetUrl
      const unattendedTargetUrl = response?.data?.url || targetUrl;
      window.open(unattendedTargetUrl, '_blank');
    } catch (error) {
      console.error('Error building unattended entry url:', error);
      // 非 200 或请求异常时回退到原始 targetUrl
      window.open(targetUrl, '_blank');
    }
  }




  // 格式化最后登录时间
  formatLastLogin(user) {
    if (!user || !user.lastSeenAt) {
      return app.translator.trans('tf-groups.forum.group-detail.never');
    }
    const lastSeen = new Date(user.lastSeenAt());
    const now = new Date();
    const diffMs = now - lastSeen;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffHours < 1) {
      return app.translator.trans('tf-groups.forum.group-detail.just-now');
    } else if (diffHours < 24) {
      return `${diffHours} ${diffHours === 1 ? app.translator.trans('tf-groups.forum.group-detail.hour') : app.translator.trans('tf-groups.forum.group-detail.hours')} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} ${diffDays === 1 ? app.translator.trans('tf-groups.forum.group-detail.day') : app.translator.trans('tf-groups.forum.group-detail.days')} ago`;
    } else {
      return lastSeen.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    }
  }

  // 格式化加入日期
  formatJoinedDate(user) {
    if (!user || !user.joinedAt) {
      return app.translator.trans('tf-groups.forum.group-detail.unknown');
    }
    const joined = new Date(user.joinedAt());
    return joined.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  // 获取用户积分
  getUserPoints(user) {
    if (!user) return '0';
    // 尝试从用户属性中获取积分
    // 如果项目使用了 tf/points 扩展，可能需要通过特定方法获取
    if (user.attributes && user.attributes.points) {
      return Number(user.attributes.points).toLocaleString();
    }
    // 尝试从其他可能的属性获取
    if (user.points) {
      return Number(user.points()).toLocaleString();
    }
    return '0';
  }

  // 从 creator 数据格式化最后登录时间
  formatLastLoginFromCreator(creator) {
    if (!creator || !creator.last_seen_at) {
      return app.translator.trans('tf-groups.forum.group-detail.never');
    }
    const lastSeen = new Date(creator.last_seen_at);
    const now = new Date();
    const diffMs = now - lastSeen;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffHours < 1) {
      return app.translator.trans('tf-groups.forum.group-detail.just-now');
    } else if (diffHours < 24) {
      return `${diffHours} ${diffHours === 1 ? app.translator.trans('tf-groups.forum.group-detail.hour') : app.translator.trans('tf-groups.forum.group-detail.hours')} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} ${diffDays === 1 ? app.translator.trans('tf-groups.forum.group-detail.day') : app.translator.trans('tf-groups.forum.group-detail.days')} ago`;
    } else {
      return lastSeen.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    }
  }

  // 从 creator 数据格式化加入日期
  formatJoinedDateFromCreator(creator) {
    if (!creator || !creator.joined_at) {
      return app.translator.trans('tf-groups.forum.group-detail.unknown');
    }
    const joined = new Date(creator.joined_at);
    return joined.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  // 从 creator 数据格式化积分
  formatPointsFromCreator(creator) {
    if (!creator) return '0';
    const points = creator.remote_points || 0;
    return Number(points).toLocaleString();
  }

  // 检查用户成员状态
  checkMemberStatus() {
    if (!app.session.user) {
      this.isMember = false;
      this.isAdmin = false;
      this.memberStatus = null;
      return;
    }

    // 直接从group数据中的user_status字段获取用户状态
    if (this.group && this.group.user_status) {
      const userStatus = this.group.user_status;
      
      // 根据user_status判断用户状态
      this.memberStatus = userStatus.status; // 'approved', 'pending', null
      this.isMember = userStatus.status === 'approved';
      this.isAdmin = userStatus.role === 'admin' || userStatus.role === 'moderator';
    } else {
      // 如果没有user_status字段，说明用户不是群组成员
      this.memberStatus = null;
      this.isMember = false;
      this.isAdmin = false;
    }
  }

  // 加入群组
  async joinGroup() {
    if (!app.session.user) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.please-login'));
      return;
    }

    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/social-groups/' + this.groupId + '/join'
      });

      app.alerts.show({ type: 'success' }, app.translator.trans('tf-groups.forum.group-detail.join-success'));
      
      // 更新用户状态为已加入，直接展示为成员
      if (this.group.user_status) {
        this.group.user_status.status = 'approved';
        this.group.user_status.role = 'member';
        this.group.user_status.joined_at = this.group.user_status.joined_at || new Date().toISOString();
      } else {
        this.group.user_status = {
          role: 'member',
          status: 'approved',
          joined_at: new Date().toISOString()
        };
      }
      
      // 重新检查成员状态
      this.checkMemberStatus();
      m.redraw();
    } catch (error) {
      console.error('Error joining group:', error);
      const errorMessage = error.response?.data?.error || app.translator.trans('tf-groups.forum.group-detail.join-error');
      app.alerts.show({ type: 'error' }, errorMessage);
    }
  }

  // 退出群组
  async leaveGroup() {
    if (!app.session.user) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.please-login'));
      return;
    }

    if (!confirm(app.translator.trans('tf-groups.forum.group-detail.leave-confirm'))) {
      return;
    }

    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/social-groups/' + this.groupId + '/leave'
      });

      app.alerts.show({ type: 'success' }, app.translator.trans('tf-groups.forum.group-detail.leave-success'));
      
      // 清除用户状态
      this.group.user_status = null;
      
      // 重新检查成员状态
      this.checkMemberStatus();
      m.redraw();
    } catch (error) {
      console.error('Error leaving group:', error);
      const errorMessage = error.response?.data?.error || app.translator.trans('tf-groups.forum.group-detail.leave-error');
      app.alerts.show({ type: 'error' }, errorMessage);
    }
  }

  // 发布主题
  async postTopic() {
    // 检查用户是否登录
    if (!app.session.user) {
      app.modal.show('flarum/forum/components/LogInModal');
      return;
    }

    // 检查当前路由是否为群组详情页
    const currentRoute = m.route.get();
    if (!currentRoute || !currentRoute.includes('/groups/')) {
      // 如果不在群组详情页，使用默认行为
      app.composer.load(DiscussionComposer, {});
      app.composer.show();
      return;
    }

    // 从路由中获取群组ID
    const routeGroupId = m.route.param('id');
    if (!routeGroupId || routeGroupId !== this.groupId) {
      // 如果路由中的群组ID与当前群组ID不匹配，使用默认行为
      app.composer.load(DiscussionComposer, {});
      app.composer.show();
      return;
    }

    try {
      // 重新查询群组数据以获取最新的用户权限状态
      const groupResponse = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups/frontend/' + this.groupId
      });

      if (!groupResponse || !groupResponse.data) {
        app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.load-error'));
        return;
      }

      // 更新群组数据
      this.group = groupResponse.data;
      
      // 重新检查用户成员状态
      this.checkMemberStatus();

      // 检查用户是否有权限（必须是群组成员或管理员）
      if (!this.isMember && !this.isAdmin) {
        app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.no-permission-to-post'));
        return;
      }

      // 检查群组是否有关联的标签
      if (!this.group || !this.group.tag) {
        app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.no-tag-error'));
        return;
      }

      // 获取标签信息（来自 social-groups/frontend 接口返回的 tag）
      const tag = this.group.tag;
      const tagId = tag?.id || this.group.tag_id;
      if (!tagId) {
        app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.tag-incomplete-error'));
        return;
      }

      // 加载讨论创建器
      app.composer.load(DiscussionComposer, {});

      // 在 show 之前同步设置 composer.fields.tags，使 DiscussionComposer-changeTags 默认显示当前群组
      let tagModel = app.store.getById('tags', tagId);
      if (!tagModel && tag) {
        app.store.pushPayload({
          data: {
            type: 'tags',
            id: String(tag.id),
            attributes: {
              name: tag.name || '',
              slug: tag.slug || '',
              color: tag.color || null,
              icon: tag.icon || null,
              position: 0,
              isChild: false,
              isHidden: false,
              canStartDiscussion: true,
              canAddToDiscussion: true
            }
          }
        });
        tagModel = app.store.getById('tags', tagId);
      }
      if (tagModel && app.composer.fields) {
        app.composer.fields.tags = [tagModel];
      }

      // 显示创建器
      app.composer.show();
    } catch (error) {
      console.error('Error checking group permission:', error);
      app.alerts.show({ type: 'error' }, app.translator.trans('tf-groups.forum.group-detail.load-error'));
    }
  }

  // 渲染群组操作按钮
  renderGroupActions() {
    // 如果是父群组，不显示加入群组按钮
    if (this.group.is_container) {
      return null;
    }

    // if (!app.session.user) {
    //   return (
    //     <div className="group-actions">
    //       <Button className="Button Button--primary" onclick={() => app.modal.show('flarum/forum/components/LogInModal')}>
    //         登录后加入群组
    //       </Button>
    //     </div>
    //   );
    // }

    if (this.memberStatus === 'pending') {
      return (
        <div className="group-actions">
          <Button className="Button Button--disabled" disabled>
            {app.translator.trans('tf-groups.forum.group-detail.application-pending')}
          </Button>
        </div>
      );
    }

    if (this.isMember) {
      return (
        <div className="group-actions">
          <Button className="Button group-leave-button" onclick={() => this.leaveGroup()}>
            {app.translator.trans('tf-groups.forum.group-detail.leave-group')}
          </Button>
        </div>
      );
    }

    // return (
      // <div className="group-actions">
      //   <Button className="Button group-join-button" onclick={() => this.joinGroup()}>
      //     Join this Group
      //   </Button>
      // </div>
    // );

    // return (
    //   <div className="group-actions">
    //     <Button className="Button Button--primary" onclick={() => this.joinGroup()}>
    //       加入群组
    //     </Button>
    //   </div>
    // );
  }

  // 渲染讨论列表（非课程类型）
  renderDiscussionsList() {
    if (this.discussionListState) {
      return <DiscussionList state={this.discussionListState} />;
    } else {
      return (
        <div className="discussions-list-empty">
          <p>{app.translator.trans('tf-groups.forum.group-detail.no-discussions-yet')}</p>
        </div>
      );
    }
  }

  // 渲染课程卡片网格（课程类型）
  renderCourseLessons() {
    if (!this.discussionListState || !this.discussionListState.pages || this.discussionListState.pages.length === 0) {
      return (
        <div className="course-lessons-empty">
          <p>{app.translator.trans('tf-groups.forum.group-detail.no-discussions-yet')}</p>
        </div>
      );
    }

    // 获取所有讨论
    const allDiscussions = [];
    this.discussionListState.pages.forEach(page => {
      if (page.items && Array.isArray(page.items)) {
        allDiscussions.push(...page.items);
      }
    });

    if (allDiscussions.length === 0) {
      return (
        <div className="course-lessons-empty">
          <p>{app.translator.trans('tf-groups.forum.group-detail.no-discussions-yet')}</p>
        </div>
      );
    }

    return (
      <div className="course-lessons-grid-container">
        {allDiscussions.map(discussion => this.renderCourseLessonCard(discussion))}
      </div>
    );
  }

  // 跳转详情前清除讨论缓存，强制重新请求以获取最新解锁状态
  clearDiscussionCache(discussion) {
    if (!discussion) return;
    const firstPost = discussion.firstPost && discussion.firstPost();
    if (firstPost) {
      app.store.remove(firstPost);
    }
    app.store.remove(discussion);
  }

  // 兑换成功后刷新课程访问权限，使锁定的课程立即解锁
  async refreshCourseAccess() {
    if (!this.discussionListState || !this.discussionListState.pages) return;
    const allDiscussions = [];
    this.discussionListState.pages.forEach(page => {
      if (page.items && Array.isArray(page.items)) {
        allDiscussions.push(...page.items);
      }
    });
    if (allDiscussions.length > 0) {
      await this.checkDiscussionsAccess(allDiscussions);
      m.redraw();
    }
  }

  // 批量检查讨论列表的课程访问权限
  async checkDiscussionsAccess(discussions) {
    const user = app.session.user;
    if (!user) {
      return;
    }

    // 管理员有所有权限
    if (user.attribute('isAdmin')) {
      discussions.forEach(discussion => {
        if (discussion) {
          discussion._hasCourseAccess = true;
        }
      });
      return;
    }

    // 如果是群组成员，所有课程都有权限
    if (this.isMember) {
      discussions.forEach(discussion => {
        if (discussion) {
          discussion._hasCourseAccess = true;
        }
      });
      return;
    }

    // 获取所有付费课程
    const paidDiscussions = discussions.filter(discussion => {
      if (!discussion) return false;
      const courseInfo = discussion.attribute('groupCourse') || null;
      return courseInfo && (courseInfo.price > 0 || courseInfo.courseType === 'paid');
    });

    if (paidDiscussions.length === 0) {
      // 没有付费课程，所有都是免费的，成员有权限
      discussions.forEach(discussion => {
        if (discussion) {
          discussion._hasCourseAccess = this.isMember;
        }
      });
      return;
    }

    // 批量检查用户是否有该群组的激活码或购买记录
    try {
      // 检查购买记录
      const purchaseResponse = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/cns-courses/group-purchases',
        params: {
          'filter[socialGroupId]': this.groupId,
          'filter[userId]': user.id(),
        },
      });
      
      const purchases = purchaseResponse.data || [];
      const hasValidPurchase = purchases.some(purchase => {
        const attrs = purchase.attributes || purchase;
        return attrs.status === 'paid' && (!attrs.expiresAt || new Date(attrs.expiresAt) > new Date());
      });
      
      // 检查激活码记录
      const activationResponse = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/cns-courses/activation-codes',
        params: {
          'filter[socialGroupId]': this.groupId,
          'filter[userId]': user.id(),
          'filter[status]': 'used',
        },
      });
      
      const activations = activationResponse.data || [];
      const hasValidActivation = activations.some(activation => {
        const attrs = activation.attributes || activation;
        return attrs.status === 'used' && (!attrs.expiresAt || new Date(attrs.expiresAt) > new Date());
      });
      
      const hasAccess = hasValidPurchase || hasValidActivation;
      
      // 为每个讨论设置权限状态
      discussions.forEach(discussion => {
        if (!discussion) return;
        const courseInfo = discussion.attribute('groupCourse') || null;
        const isPaid = courseInfo && (courseInfo.price > 0 || courseInfo.courseType === 'paid');
        
        if (isPaid) {
          discussion._hasCourseAccess = hasAccess;
        } else {
          // 免费课程，成员有权限
          discussion._hasCourseAccess = this.isMember;
        }
      });
    } catch (error) {
      console.error('Failed to check discussions access:', error);
      // 出错时，默认没有权限
      discussions.forEach(discussion => {
        if (discussion) {
          const courseInfo = discussion.attribute('groupCourse') || null;
          const isPaid = courseInfo && (courseInfo.price > 0 || courseInfo.courseType === 'paid');
          discussion._hasCourseAccess = !isPaid && this.isMember;
        }
      });
    }
  }

  // 检查用户是否有课程访问权限（单个讨论）
  async checkCourseAccess(discussion) {
    const user = app.session.user;
    if (!user) {
      return false;
    }

    // 管理员有所有权限
    if (user.attribute('isAdmin')) {
      return true;
    }

    // 检查用户是否是群组成员（成员有访问权限）
    if (this.isMember) {
      return true;
    }

    // 对于付费课程，需要检查是否有激活码或购买记录
    const courseInfo = discussion.attribute('groupCourse') || null;
    const isPaid = courseInfo && (courseInfo.price > 0 || courseInfo.courseType === 'paid');
    
    if (isPaid) {
      // 检查用户是否有该群组的激活码或购买记录
      try {
        const response = await app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/cns-courses/group-purchases',
          params: {
            'filter[socialGroupId]': this.groupId,
            'filter[userId]': user.id(),
          },
        });
        
        // 如果有购买记录且状态为 paid，则有权限
        const purchases = response.data || [];
        const hasValidPurchase = purchases.some(purchase => {
          const attrs = purchase.attributes || purchase;
          return attrs.status === 'paid' && (!attrs.expiresAt || new Date(attrs.expiresAt) > new Date());
        });
        
        if (hasValidPurchase) {
          return true;
        }
        
        // 检查激活码记录
        const activationResponse = await app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/cns-courses/activation-codes',
          params: {
            'filter[socialGroupId]': this.groupId,
            'filter[userId]': user.id(),
            'filter[status]': 'used',
          },
        });
        
        const activations = activationResponse.data || [];
        const hasValidActivation = activations.some(activation => {
          const attrs = activation.attributes || activation;
          return attrs.status === 'used' && (!attrs.expiresAt || new Date(attrs.expiresAt) > new Date());
        });
        
        return hasValidActivation;
      } catch (error) {
        console.error('Failed to check course access:', error);
        return false;
      }
    }
    
    // 免费课程，成员有权限
    return this.isMember;
  }

  // 渲染单个课程卡片
  renderCourseLessonCard(discussion) {
    if (!discussion) return null;

    // 获取课程信息（从 attributes 中获取）
    const courseInfo = discussion.attribute('groupCourse') || null;
    const isPaid = courseInfo && (courseInfo.price > 0 || courseInfo.courseType === 'paid');
    
    // 检查用户是否有权限（优先使用已缓存的权限状态）
    const hasAccess = discussion._hasCourseAccess !== undefined 
      ? discussion._hasCourseAccess 
      : (app.session.user && (app.session.user.attribute('isAdmin') || this.isMember));
    
    // 如果已兑换，不显示锁图标
    const shouldShowLock = isPaid && !hasAccess;
    
    // 根据课程类型和访问权限获取描述：优先使用后台配置的 Preview Content（免费与付费课程均显示）
    let description = '';
    if (courseInfo && courseInfo.previewContent) {
      // 有后台配置的 Preview Content 时优先使用
      const textContent = String(courseInfo.previewContent).replace(/<[^>]*>/g, '').trim();
      description = textContent.length > 150 ? textContent.substring(0, 150) + '...' : textContent;
    } else if (!isPaid || hasAccess) {
      // 无 Preview Content 时：已解锁的付费课程或免费课程显示首帖内容
      const firstPost = discussion.firstPost();
      if (firstPost) {
        const content = firstPost.contentPlain ? firstPost.contentPlain() : (firstPost.content ? firstPost.content() : '');
        if (content) {
          const textContent = String(content).replace(/<[^>]*>/g, '').trim();
          description = textContent.length > 150 ? textContent.substring(0, 150) + '...' : textContent;
        }
      }
    }

    // 获取封面图片（优先使用后台配置的 coverImage，然后是 customThumbnail，最后是 thumbnail）
    const courseCoverImage = courseInfo?.coverImage || null;
    const customThumbnail = discussion.attribute('customThumbnail') || null;
    const thumbnail = discussion.attribute('thumbnail') || null;
    const coverImage = courseCoverImage || customThumbnail || thumbnail || null;
    const coverImageUrl = coverImage ? this.getImageUrl(coverImage) : null;

    return (
      <div 
        key={discussion.id()} 
        className={`course-lesson-card ${shouldShowLock ? 'course-lesson-card--locked' : ''}`}
        onclick={async (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // 如果已兑换，直接跳转
          if (hasAccess) {
            this.clearDiscussionCache(discussion);
            m.route.set(app.route('discussion', { id: discussion.slug() }));
            return;
          }
          
          if (isPaid) {
            // 如果是付费课程且没有权限
            // 未登录时跳转登录
            if (!app.session.user) {
              app.modal.show(LogInModal);
              return;
            }
            
            // 已登录但没有权限，显示激活码弹窗
            if (app.activateCodeModal) {
              app.modal.show(app.activateCodeModal, {
                onSuccess: () => this.refreshCourseAccess()
              });
            }
          } else {
            // 免费课程，直接跳转到讨论详情
            m.route.set(app.route('discussion', { id: discussion.slug() }));
          }
        }}
      >
        {/* 课程封面图片 */}
        <div className="course-lesson-card-image">
          {coverImageUrl ? (
            <img src={coverImageUrl} alt={discussion.title()} />
          ) : (
            <div className="course-lesson-card-image-placeholder">
              <i className="fa-light fa-book"></i>
            </div>
          )}
          {/* 付费课程锁图标 - 只在未兑换时显示 */}
          {shouldShowLock && (
            <div className="course-lesson-card-lock">
              <i className="fa-solid fa-lock"></i>
            </div>
          )}
        </div>

        {/* 课程信息 */}
        <div className="course-lesson-card-content">
          <h3 className="course-lesson-card-title">{discussion.title()}</h3>
          {description && (
            <p className="course-lesson-card-description">{description}</p>
          )}
        </div>
      </div>
    );
  }
}
